import { SEARCH_PARAM_KEY_CALLBACK_URL } from '@/consts/search-param-keys';

function isSafeRelativePath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//');
}

export function getPmsCallbackUrlFromSearch(): string | null {
  if (typeof window === 'undefined') return null;

  const raw = new URLSearchParams(window.location.search).get(SEARCH_PARAM_KEY_CALLBACK_URL);
  if (!raw) return null;

  try {
    const decoded = decodeURIComponent(raw);
    if (isSafeRelativePath(decoded)) {
      return decoded;
    }
  } catch {
    return null;
  }

  return null;
}

export function getEncodedCurrentPath(): string | null {
  if (typeof window === 'undefined') return null;

  const currentPath = `${window.location.pathname}${window.location.search}`;
  try {
    return encodeURIComponent(currentPath);
  } catch {
    return null;
  }
}
